import { Draft } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

function createFailure(draft: Draft<IWorkerData>) {
  draft.create.config.isLoading = false;
}

export default createFailure;
